import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useRouteMatch } from 'react-router';

import { config } from 'src/config';
import { useNonce } from 'src/shared/hooks';
import { Route } from 'src/shared/route';

import { snippet } from './snippet';

const Vwo = () => {
  const nonce = useNonce();

  const isRouteAllowed = useRouteMatch([
    Route.SIGN_UP_PROFESSIONAL.path,
    Route.SIGN_UP_PROFESSIONAL_SURVEY.path,
    Route.SIGN_UP_PROFESSIONAL_UPGRADE.path,
    Route.SIGN_UP_PROFESSIONAL_SSO.path,
    Route.SIGN_UP_INSURANCE.path,
    Route.SIGN_UP_INSURANCE_ORGANIZATION.path,
    Route.SIGN_UP_INSURANCE_SURVEY.path,
  ]);

  if (!config.VWO_ACCOUNT_ID || !isRouteAllowed) return null;

  return (
    <Helmet>
      <link href="https://dev.visualwebsiteoptimizer.com" rel="preconnect" />
      <script id="vwoCode" nonce={nonce} type="text/javascript">
        {snippet(config.VWO_ACCOUNT_ID)}
      </script>
    </Helmet>
  );
};

export { Vwo };
